const Footer = () => {
    return(
        <>
        <footer>
            <div className="company">
                <h2>Company</h2>
                <p>About us</p>
                <p>Careers</p>
                <p>Terms of Service</p>
                <p>Privacy policy</p>
                <p>Cookie policy</p>
            </div>
            <div className="resources">
                <h2>Resources</h2>
                <p>Help</p>
                <p>Blog</p>
                <p>Refer a friend</p>
                <p>Research updates</p>
                <p>Blue Poop Challenge</p>
                <p>ZOE Health Study</p>
            </div>
        </footer>
        <div className="line2"></div>
        <p className="copyright">©2022ZOE Limited</p>
        </>
    );
}

export default Footer;